import { NearbyArtistsDisplayState } from './display.types';

export const getDefaultDisplay = (): NearbyArtistsDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: NearbyArtistsDisplayState = getDefaultDisplay();
